import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import { getCustomStyles } from "../Utilities";
import { Validator } from "../Validation/Validator";
import ValidationSummary from "../Validation/ValidationSummary";
import Checkbox from "../Checkbox";
import {
  getAllFormElements,
  showValidationErrors,
  resetValidationErrors,
} from "../Utilities";
import SmallSpinner from "../SmallSpinner";
import Select from "react-select";

let sizeOptions: any[];

interface Props {
  onToaster: any;
}

interface State {
  shippingTypeValue: any;
  sizeValue: string;
  sizeId: number;
  price: number;
  enabled: boolean;
  redirect: boolean;
  formErrors: any;
  isLoading: boolean;
  recaptcha: any;
  recaptchaResult: boolean;
  shippingDetails: any;
  sizes: any;
  shipping: any;
  selectedSize: any;
  renderCount: number;
}

class AddShippingForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      shippingTypeValue: null,
      sizeValue: "",
      sizeId: 0,
      price: 0,
      enabled: true,
      redirect: false,
      formErrors: [],
      isLoading: false,
      recaptcha: {},
      recaptchaResult: false,
      shippingDetails: null,
      sizes: [],
      shipping: [],
      selectedSize: null,
      renderCount: 0,
    };
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.save = this.save.bind(this);
  }
  loadSizes = async (): Promise<any> => {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        this.setState(
          {
            sizes: result.Data,
          },
          () => {
            sizeOptions = this.state.sizes.map((item: any) => {
              return { label: item.SizeValue, value: item.SizeId };
            });
            this.setState({ renderCount: this.state.renderCount + 1 });
          }
        );
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        console.log(error.response ? error.message : "Unknown Error");
      }
    };
    MakeRequest({
      url: "Painting/GetAllSizes",
      method: "get",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  loadShipping = async (): Promise<any> => {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        this.setState({
          shipping: result.Data,
        });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        console.log(error.response ? error.message : "Unknown Error");
      }
    };
    MakeRequest({
      url: "Admin/GetAllShipping",
      method: "get",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  postData(data: any): void {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result !== undefined) {
        //do logic
        if (result.Success === true) {
          this.props.onToaster(
            { success: true },
            "Success: Shipping value added"
          );
          this.setState({
            shippingTypeValue: "",
            sizeValue: "",
            sizeId: 0,
            price: 0,
            enabled: true,
            isLoading: false,
            selectedSize: null,
          });
        } else {
          this.props.onToaster({ error: true }, "Error: " + result.Message);
          this.setState({ isLoading: false });
        }
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        this.setState({ isLoading: false }, () => {
          this.props.onToaster(
            { error: true },
            error.response ? error.message : "Unknown Error"
          );
        });
        if (
          error.response &&
          error.response.status &&
          error.response.status === 401
        ) {
        }
      }
    };
    MakeRequest({
      url: "Admin/AddShipping",
      method: "post",
      data: { postData: data },
      successCallback,
      errorCallback,
    });
  }
  handleBlurValidation = (e: any) => {
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  handleFocus = (e: any) => {
    this.setState({ formErrors: [] }, () => {
      resetValidationErrors(e.target);
    });
  };
  handleTypeChange = (e: any) => {
    this.setState({ shippingTypeValue: e });
  };
  handleSizeChange = (e: any) => {
    this.setState({ sizeValue: e.label, sizeId: e.value, selectedSize: e });
  };
  handlePriceChange = (e: any) => {
    this.setState({ price: parseFloat(e.target.value) });
  };
  handleCheckBoxChange = (e: any) => {
    this.setState({ enabled: e.target.checked });
  };

  shippingTypeOptions = (): any => {
    let options: any[] = [
      { label: "Painting", value: "0" },
      { label: "Print", value: "1" },
    ];
    return options;
  };

  save = async (e: any) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    /*let result: any = await this.getRecaptchaToken();

    //this still needs to be implemented
    //need to wait for this result before moving on
    if (result !== "") {
      await this.recaptcha({ Response: result });
    }*/

    const type: any = this.state.shippingTypeValue;
    const size: string = this.state.sizeValue.trim();
    const sizeId: number = this.state.sizeId;
    const price: number = this.state.price;
    const enabled: boolean = this.state.enabled;

    let form = document.getElementById("addShippingForm");
    let allFormElements = getAllFormElements({ element: form ? form : e });
    let errors = Validator({ fields: allFormElements });

    // do select
    if (type === null) {
      let error = {
        fieldName: "shippingType",
        message: "Shipping type is required",
      };
      errors?.push(error);
    } else {
      //check to see if we already have the same shipping value
      let shippingValueFound: any = this.state.shipping.find(
        (item: any) =>
          item.Type === parseInt(type.value) && item.SizeId === sizeId
      );

      if (shippingValueFound) {
        let error = {
          fieldName: "size",
          message: "This shipping value already exists",
        };
        errors?.push(error);
      }
    }

    //do size format check
    ///\d{2} [xX] \d{2}/gm is 00 X 00
    let pattern = size.search(/\d{2} [xX] \d{2}/gm);
    if (pattern === -1) {
      let error = {
        fieldName: "size",
        message: "Size should follow this format e.g 40 X 40",
      };
      errors?.push(error);
    }

    if (errors.length === 0) {
      //update state
      let shippingDetails: any = {
        Type: parseInt(type.value),
        Size: size,
        SizeId: sizeId,
        Price: price,
        Enabled: enabled,
      };
      this.setState(
        { shippingDetails: shippingDetails, formErrors: [] },
        () => {
          resetValidationErrors(e.target);
          //save the data
          this.postData(shippingDetails);
        }
      );
    } else {
      this.setState({ isLoading: false, formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  componentDidMount(): void {
    this.loadSizes();
    this.loadShipping();
  }

  render() {
    return (
      <div className="col-md-6">
        <div className="card-form">
          <h5 className="card-title">New Shipping Value</h5>
          <hr />
          <div className="center">
            <SmallSpinner
              isLoading={this.state.isLoading}
              actionText="Loading"
            />
          </div>
          <ValidationSummary Errors={this.state.formErrors} />
          <form id="addShippingForm" onSubmit={this.save}>
            <div className="form-group">
              <label htmlFor="shippingType" className="label-dark">
                Type
              </label>
              <Select
                id="shippingType"
                value={this.state.shippingTypeValue}
                onChange={this.handleTypeChange}
                options={this.shippingTypeOptions()}
                styles={getCustomStyles()}
              />
            </div>
            <div className="form-group">
              <label htmlFor="sizes" className="label-dark">
                Size
              </label>
              <Select
                key={"sizes_" + this.state.renderCount}
                id="sizes"
                value={this.state.selectedSize}
                defaultValue={this.state.selectedSize || "Select"}
                onChange={this.handleSizeChange}
                options={sizeOptions}
                styles={getCustomStyles()}
              />
            </div>
            <div className="form-group">
              <label htmlFor="price" className="label-dark">
                Price
              </label>
              <input
                id="price"
                className="form-control border-input"
                type="number"
                value={this.state.price}
                onChange={this.handlePriceChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Price"
                data-required="true"
                data-min="1"
                data-validationname="Price"
                data-id="price"
              />
            </div>
            <div className="form-group">
              <div className="form-group">
                <Checkbox
                  id="enabled"
                  label="Is Enabled?"
                  checked={this.state.enabled}
                  onSelecting={this.handleCheckBoxChange}
                  datarequired={false}
                  labelClass="label-dark"
                  data-validationname="Is Enabled"
                  data-id="enabled"
                />
              </div>
            </div>
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-success btn-round"
                data-id="shippingButton"
              >
                Save Shipping Value
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddShippingForm;
